import React from "react"
import {Box} from "@mui/material"

export const widgetImagePrototype = [
        {
          "key": "imageName",
          "type": "STRING",
          "label": "Bildname",
          "size": 6
        },
    {
          "key": "maxHeight",
          "type": "INTEGER",
          "label": "Maximalhöhe (in px)",
          "size": 6
        },
        {
          "key": "localImage",
          "type": "CHECKBOX",
          "label": "Lokales Bild",
          "size": 6
        },
      ]

const ImageWidget = ({widget, value}) => {
    const displayValue = value ?? widget.imageName
    const url = widget.localImage ? displayValue : globalThis._env_.ARBEITSKONSOLE_SERVER_URL + displayValue
    return (
        <Box
            width="100%"
            display="flex"
            alignItems="center"
            sx={{objectFit: "contain", overflow: "hidden"}}>
            {displayValue ? (
                <img
                    width="100%"
                    style={{objectFit: "cover", maxHeight: widget.maxHeight + "px"}}
                    src={url}
                />
            ) : (
                <>No Image</>
            )}
        </Box>
    )
}

export default ImageWidget